export default __webpack_public_path__ + "media/logos/blue_2x-21e32df2.png";